import { TypeLocation } from "../types/Type_Weather";

export const datacountries: TypeLocation[] = [
  {
    name: 'Lima',
    lat: 40.7399785,
    lon: -84.105006,
    country: 'PE',
    state: 'Lima'
  },
  {
    name: 'Huacho',
    lat: -11.108524,
    lon: -77.6103295,
    country: 'PE',
    state: 'Lima'
  },
  {
    name: 'Miami',
    lat: 25.7741728,
    lon: -80.19362,
    country: 'US',
    state: 'Florida'
  }
]